export function calculateCurrentStep(progress: number, totalSteps: number): number {
  const stepSize = 100 / totalSteps;
  return Math.min(Math.floor(progress / stepSize) + 1, totalSteps);
}
